/* unplugin-vue-components disabled */import script from "./eat-set.vue?vue&type=script&setup=true&lang=ts"
export * from "./eat-set.vue?vue&type=script&setup=true&lang=ts"

import "./eat-set.vue?vue&type=style&index=0&id=0f74b53a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f74b53a"]])

export default __exports__